import { Rive, RuntimeLoader } from '@rive-app/canvas';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const STATE_MACHINES_NAME = 'ep240k';

const setup = () => {
  const triggers = document.querySelectorAll('[data-w-section-header]');

  triggers.forEach((trigger) => {
    const canvas = trigger.querySelector('canvas');
    if (!canvas) return;

    const container = trigger.querySelector('[data-w-rive-parent]');
    const identifier = canvas.getAttribute('data-w-identifier') ?? false;
    const artboard = canvas.getAttribute('data-w-artboard');
    const src = canvas.getAttribute('data-w-rive');

    if (identifier === 'soundwave') {
      const rv = new Rive({
        canvas,
        src,
        artboard: artboard,
        autoBind: true,
        autoplay: true,
        stateMachines: STATE_MACHINES_NAME,
        onLoad: () => {
          // gsap.to(trigger, {
          //   scrollTrigger: {
          //     trigger: trigger,
          //     start: 'top bottom',
          //     end: 'bottom top',
          //     scrub: true,
          //     onUpdate: (self) => {
          //       trigger.style.setProperty('--_progress', -0.5 + self.progress);
          //     },
          //   },
          // });

          const vmi = rv.viewModelInstance;
          const volume = vmi.number('volume');
          volume.value = 100; // init

          gsap.to(container, {
            scrollTrigger: {
              trigger: container,
              start: 'center center',
              end: () => `+=${window.innerHeight * 0.1}`,
              onUpdate: (self) => {
                volume.value = (1 - self.progress) * 100;
                container.style.setProperty('--_value', 1 - self.progress);
              },
            },
          });

          rv.resizeDrawingSurfaceToCanvas();
        },
      });

      gsap.to(trigger, {
        scrollTrigger: {
          trigger: trigger,
          start: 'top bottom',
          end: 'bottom top',
          // fastScrollEnd: true,
          onEnter: () => {
            rv.startRendering();
            // rv.play(STATE_MACHINES_NAME, true);
          },
          onEnterBack: () => {
            rv.startRendering();
            // rv.play(STATE_MACHINES_NAME, true);
          },
          onLeaveBack: () => {
            // rv.pause(STATE_MACHINES_NAME);
            rv.stopRendering();
          },
          onLeave: () => {
            // rv.pause(STATE_MACHINES_NAME);
            rv.stopRendering();
          },
        },
      });
    }
  });
};

export default function SectionHeader() {
  return {
    init: () => {
      setup();
    },
  };
}
